import request from '../../shared/request'

export function getContractPaymentScheduleTemplate(templateId) {
  return request(`/contract/payment_schedule/template/${templateId}`)
}

export function getContractPaymentSchedule(contractId) {
  return request(`/contract/payment_schedule/${contractId}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/contracts.js